import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SelectableSubmission } from '../session-submissions-picker/session-submissions-picker.component';

export interface AddSessionSubmissionsData {
  submissions: SelectableSubmission[];
  sessionId: number;
  sessionTitleById: Map<number, string>;
}

/**
 * Diálogo "Adicionar submissão" — aberto pelo card fantasma da aba
 * "Submissões V2".
 *
 * O conteúdo é o MESMO componente da aba "Submissões"
 * (`app-session-submissions-picker`), acrescido de Descartar/Salvar.
 *
 * A seleção é escrita direto nos objetos recebidos (é a mesma lista do diálogo
 * de sessão). Por isso guardamos um retrato das marcações ao abrir: "Descartar"
 * restaura esse retrato, senão as alterações feitas aqui vazariam para o
 * diálogo de trás mesmo tendo sido descartadas.
 */
@Component({
  selector: 'app-add-session-submissions-dialog',
  templateUrl: './add-session-submissions-dialog.component.html',
  styleUrls: ['./add-session-submissions-dialog.component.scss'],
})
export class AddSessionSubmissionsDialogComponent {
  private readonly initialSelection = new Map<number, Boolean>();

  constructor(
    public dialogRef: MatDialogRef<AddSessionSubmissionsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AddSessionSubmissionsData,
  ) {
    (this.data.submissions || []).forEach(item => this.initialSelection.set(item.id, item.selected));
  }

  /** Houve mudança de marcação desde a abertura? Habilita "Salvar". */
  get hasChanges(): boolean {
    return (this.data.submissions || [])
      .some(item => !!item.selected !== !!this.initialSelection.get(item.id));
  }

  /**
   * Rótulo do botão da esquerda: sem alteração pendente ele apenas fecha, e
   * chamá-lo de "Descartar" prometeria algo que não acontece. Mesma regra do
   * diálogo de sessão.
   */
  get dismissLabel(): string {
    return this.hasChanges ? 'forms.buttons.discard' : 'forms.buttons.close';
  }

  discard(): void {
    (this.data.submissions || []).forEach(item => item.selected = this.initialSelection.get(item.id));
    this.dialogRef.close(false);
  }

  save(): void {
    this.dialogRef.close(true);
  }
}
